module.exports = __webpack_public_path__ + "static/media/background-404-desktop.8a6728da.jpg";